// @flow
/** @jsx jsx */

import { pick } from 'lodash';

import { Media } from '@zapier/common-components';
import { jsx } from '@emotion/core';

import { type Node } from 'react';

export type PropsQueriesType = {
  [string]: Object,
};

type Props = {
  /** children function that accepts props override as results */
  children: ({ [key: string]: boolean }) => Node,
  /** Object where keys are queries and properties are the props overrides
  ```
  { '(min-width: 600px)': { isFlex: true } }
  ```
  Can use theme.Screen props like
  ```
  { 'phoneOnly': { isFlex: true } }
  ```
   */
  queries: PropsQueriesType,
};

/**
 * @deprecated **Hey! Listen! ✨ This component is semi-deprecated. You might want to try `useMediaProps` instead.**
 *
 * Allows overriding of children props based on media queries
 */
const PropsQuery = ({ children, queries }: Props) => {
  const mediaQueries = Object.keys(queries).reduce(
    (acc, query) => ({
      ...acc,
      [query]: query,
    }),
    {}
  );
  return (
    <Media queries={mediaQueries}>
      {results => {
        const activeResultKeys = Object.keys(results).filter(
          key => results[key]
        );
        const activeQueries = pick(queries, activeResultKeys);
        const overrides = Object.values(activeQueries).reduce(
          (acc, override) => ({ ...acc, ...override }),
          {}
        );
        return children(overrides);
      }}
    </Media>
  );
};

PropsQuery.defaultProps = {
  queries: {},
};

export default PropsQuery;
